<template>
  <div>
    <!-- Common Component -->
    <b-container fluid>
     <BaseObject
        :object="object"
        :isNew="isNew"
        :payloads="basicItems"
        @input="reflectBasicItem"
      />
      <!-- Option components -->
      <!-- function class -->
      <b-form-group
        label-cols="3"
        :label="this.translate[object] + '分類 *'"
        :label-for="object + '_function_class'"
        label-align="left">
        <b-form-select
          v-model="basicItems.function_class"
          :options="function_class_list"
          :state="noFunctionClassValidator"
          required></b-form-select>
        <b-form-invalid-feedback :id="object+'_no'" class="text-left">
          1つ選択してください
        </b-form-invalid-feedback>
      </b-form-group>
      <!-- non functional requirements -->
      <b-form-group
        label-cols="3"
        :label="this.translate[object] + '非機能要件'"
        :label-for="object + '_function_class'"
        label-align="left">
        <b-form-textarea :id="object+'_non_functional_requirements'" rows=5 v-model="basicItems.non_functional_requirements"></b-form-textarea>
      </b-form-group>
      <!-- built in Component -->
      <ChildList
        :items="basicItems.usecases.items"
        :object="object"
        :parent_id="basicItems.no"
        v-if="!this.isNew"
      />
      <!-- Common Component -->
      <b-row align-h="center">
        <template >
          <button type="button" class="btn btn-info button_spacer" v-if="isNew" @click="createSystemFunction">作成</button>
          <button type="button" class="btn btn-info button_spacer" @click="updateSystemFunction" v-else>変更</button>
        </template>
        <button
          @click="displayResumeModal = !displayResumeModal"
          class="btn btn-outline-secondary"
        >戻る</button>
      </b-row>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？？</p>
        </b-row>
        <b-row align-h="around">
          <router-link
            class="btn btn-outline-secondary"
            to="/"
          >はい</router-link>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import BaseObject from '../../common_parts/BaseObject.vue'
import ChildList from '../../common_parts/ChildList.vue'
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'SystemFunction',
  components: {
    BaseObject,
    ChildList
  },
  data () {
    return {
      object: '',
      isNew: '',
      id: '',
      parent_id: '',
      basicItems: {
        no: '',
        name: '',
        version: '',
        revision_symbol: '',
        description: '',
        restrictions: '',
        function_class: '',
        non_functional_requirements: '',
        usecases: {
          items: []
        }
      },
      function_class_list: [],
      toast: {},
      displayResumeModal: false
    }
  },
  computed: {
    noFunctionClassValidator () {
      return this.basicItems.function_class !== ''
    },
    ...mapState(['version'])
  },
  async created () {
    this.object = this.$route.path.split('/')[1]
    this.id = this.$route.params.systemFunctionId
    // add function class list (peculiar to system functions)
    const funcClasses = await API.graphql(graphqlOperation(`
      query listFunctionClass {
        listFunctionClass{
          no
          function_class
        }
      }
    `))
    if (funcClasses.data.listFunctionClass) {
      funcClasses.data.listFunctionClass.forEach(function (elm) {
        const funcClass = {
          value: elm.function_class,
          text: elm.function_class
        }
        this.function_class_list.push(funcClass)
      }.bind(this))
    }
    // fetch basic object
    this.parent_id = this.$route.query.parent_id
    if (this.id) {
      this.isNew = false
      const func = await API.graphql(graphqlOperation(`
        query getFunction {
          getSystemFunction(no: ${this.id}, version: "${this.version}"){
            no
            name
            version
            revision_symbol
            description
            restrictions
            status
            function_class
            non_functional_requirements
            usecases {
              items {
                no
                name
                version
              }
            }
          }
        }
      `))
      // to check query result
      if (func.data.getSystemFunction) {
        this.basicItems = { ...func.data.getSystemFunction }
      } else {
        this.$router.push('/')
      }
    } else {
      this.isNew = true
      // checking parrent_id exsit on url
      if (!this.$route.query.parent_id) {
        this.makeToast('parent_id', 'parent_idが指定されていません。', 'danger')
        setTimeout(function () {
          this.$router.go(-1)
        }.bind(this), 2000)
      }
      // checking parent_id is Integer
      if (!parseInt(this.$route.query.parent_id)) {
        this.makeToast('parent_id', '無効なparent_idです。', 'danger')
        setTimeout(function () {
          this.$router.go(-1)
        }.bind(this), 2000)
      }
    }
  },
  methods: {
    reflectBasicItem (event) {
      this.basicItems = { ...event }
    },
    makeToast (title, message, variant = 'default') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    async updateSystemFunction () {
      let requestBody = ''
      requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
      requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
      requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? '' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
      requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
      requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
      requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
      requestBody += this.basicItems.function_class === '' || this.basicItems.function_class === null ? 'function_class: null\n' : `function_class: "${this.basicItems.function_class}"\n`
      requestBody += this.basicItems.non_functional_requirements === '' || this.basicItems.non_functional_requirements === null ? 'non_functional_requirements: null\n' : `non_functional_requirements: "${this.basicItems.non_functional_requirements.replace(/\r?\n/g, '\\n')}"\n`
      try {
        const updateRequest = `mutation updateSystemFunction {
          updateSystemFunction(input:{
            ${requestBody}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
          }
        }`
        this.$log.debug('=====SystemFunction Update Input=====', updateRequest)
        const response = await API.graphql(graphqlOperation(updateRequest))
        this.makeToast('正常終了', `${this.translate[this.object]}更新が完了しました。`, 'info')
        this.$log.debug('=====SystemFunction Update Success=====', response)
        this.$router.go()
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====SystemFunction Update Error=====', e)
      }
    },
    async createSystemFunction () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? '' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.function_class === '' || this.basicItems.function_class === null ? 'function_class: null\n' : `function_class: "${this.basicItems.function_class}"\n`
        requestBody += this.basicItems.non_functional_requirements === '' || this.basicItems.non_functional_requirements === null ? 'non_functional_requirements: null\n' : `non_functional_requirements: "${this.basicItems.non_functional_requirements.replace(/\r?\n/g, '\\n')}"\n`
        const createRequest = `mutation createSystemFunction {
          createSystemFunction(input:{
            ${requestBody}
            system_specification_no: ${this.parent_id}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
          }
        }`
        this.$log.debug('=====SystemFunction Create Input=====', createRequest)
        const response = await API.graphql(graphqlOperation(createRequest))
        this.makeToast('正常終了', `${this.translate[this.object]}作成が完了しました。`, 'info')
        this.$log.debug('=====SystemFunction Create=====', response)
        await this.$router.push(`/system_function/${response.data.createSystemFunction.no}`)
        this.$router.go()
      } catch (e) {
        this.$log.debug('=====SystemFunction Create Error=====', e)
        const isConditionalError = e.errors.some(
          function (elm) {
            return elm.message.includes('ConditionalCheckFailedException')
          }
        )
        if (isConditionalError) {
          this.makeToast('失敗', `作成に失敗しました。\nNoが重複していないかご確認ください。`, 'danger')
        } else {
          this.makeToast('失敗', '作成に失敗しました。\n必須項目の入力漏れがないかご確認ください。', 'danger')
        }
      }
    }
  }
}
</script>
